exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.content .title[data-v-9b8313e2] {\n  text-align: center;\n  font-size: 0.4rem;\n  color: dimgrey;\n  margin: 0.4rem 0.2rem;\n  font-weight: 500;\n}\n.content .img-qr[data-v-9b8313e2] {\n  text-align: center;\n}\n.content .info[data-v-9b8313e2] {\n  padding: 0.2rem;\n}\n.content .status-list[data-v-9b8313e2] {\n  display: flex;\n  justify-content: flex-end;\n  padding: 0.2rem;\n}\n.content .status-list .cu-button[data-v-9b8313e2] {\n  display: inline-block;\n  padding: 0.04rem 0.2rem;\n  border: 0.02rem #e14027 solid;\n  margin-right: 0.2rem;\n  border-radius: 0.15rem;\n  color: #e14027;\n  font-weight: 500;\n}\n", ""]);

// exports
